export default {
  getUrlParam: function(param) {
    var url = new URL(location.href);
    var value = url.searchParams.get(param);

    return value ? value.replace('/', '') : null;
  },
  initSearchWidget: function() {
    var search = jQuery('.search-submit');
    var parent = search.parent();

    //Cambiamos el action
    parent.attr('action', location.protocol + '//' + location.host + location.pathname);
    //Cambiamos el nombre del parametro
    parent.find('.search-field').attr('name', 'search');
    //Metemos el valor por defecto
    parent.find('.search-field').val(this.getUrlParam('search'));
    //Convertimos el enlace en un botón
    search.remove();
    parent.append('<button type="submit" class="search-submit"><i class="fas fa-search"></i></button>');
  },
  initCategoriesWidget: function() {
    var items = jQuery('.widget_categories .cat-item')
    var current = this.getUrlParam('category');

    //Cambiamos la maquetación del item
    items.each(function(index, item) {
      var cat = jQuery(item);

      //Primero, obtenemos el ID
      var id = -1;
      var classes = cat.attr('class').split(/\s+/);
      jQuery.each(classes, function(index, item) {
        if (item.indexOf('cat-item-') != -1) {
          id = item.substr(9);
        }
      });
      if (id != -1) cat.attr('data-id', id);

      var content = cat.html();
      var count = content.substring(content.indexOf('(') + 1, content.indexOf(')'));

      cat.html(content.substring(0, content.indexOf('(')));
      cat.append('<span>' + count + '</span>');
      
      if (!isNaN(current) && current == id) cat.addClass('active');
    });
    //Cambiamos la lógica por defecto
    items.on('click', function(event) {
      event.preventDefault();

      var item = jQuery(this);
      var id = item.attr('data-id');
      var href = location.protocol + '//' + location.host + location.pathname;
      if (id != -1 && id != current) href += '?category=' + id;
      location.href = href;
    })
  },
  initTagCloudWidget: function() {
    var items = jQuery('.widget_tag_cloud a');
    var current = this.getUrlParam('tag');

    items.each(function(index, item) {
      var tag = jQuery(item);

      var id = -1;
      var classes = tag.attr('class').split(/\s+/);
      jQuery.each(classes, function(index, item) {
        if (item.indexOf('tag-link-') != -1 && !isNaN(item.substr(9))) {
          id = item.substr(9);
        }
      });
      if (id != -1) tag.attr('data-id', id);

      if (id != -1 && id == current) tag.addClass('active');
    });

    items.on('click', function(event) {
      event.preventDefault();

      var item = jQuery(this);
      var id = item.attr('data-id');
      var href = location.protocol + '//' + location.host + location.pathname;
      if (id != -1 && id != current) href += '?tag=' + id;
      location.href = href;
    });
  },
  initCommentLinks: function() {
    jQuery('.comment-count').on('click', function(e) {
      e.preventDefault();

      location.href = jQuery(this).attr('data-link');
    })
  },
  init() {
    this.initSearchWidget();
    this.initCategoriesWidget();
    this.initTagCloudWidget();
    this.initCommentLinks();
  },
};



// WEBPACK FOOTER //
// resources/assets/scripts/routes/lpf-journal.js